export const RouteUrl = {
  home: '/',
  admin: '/admin',
  providerSearch: '/providers/global/search',
  providerSearchResults: '/providers/global/search/results',
  providerManage: '/providers/manage',
  providerCreate: '/providers/create',
  providerEdit: '/providers/edit/:id',
  eventsSearch: '/events/search',
  riskScores: '/risk-scores',
  linkAnalysis: '/link-analysis',
  logout: '/logout',
};

export function isRoute(route: string) {
  return window.location.pathname.endsWith(route);
}
